import React from 'react';
import { useTranslation } from 'react-i18next';
import InputWithIcon from '../generics/input-with-icon';
import { User, Mail, Phone, UserCircle, Info } from 'lucide-react';

interface ClientFormProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  onChange: (field: 'firstName' | 'lastName' | 'email' | 'phone', value: string) => void;
}

/**
 * Formulaire pour les informations client
 */
const ClientForm: React.FC<ClientFormProps> = ({ firstName, lastName, email, phone, onChange }) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="flex items-center mb-6">
        <div className="mr-3 p-2 bg-primary/10 rounded-full">
          <UserCircle className="h-5 w-5 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-gray-800">
          {t('booking.clientInfo', 'Vos informations')}
        </h3>
      </div>
      
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <InputWithIcon
            label={t('booking.firstName', 'Prénom')}
            icon={<User size={16} className="text-primary" />}
            type="text"
            name="firstName"
            placeholder="Votre prénom"
            value={firstName}
            onChange={(e) => onChange('firstName', e.target.value)}
            required
            disableDarkMode={true}
            className="bg-gray-50/50 focus:bg-white transition-colors duration-200"
          />
          
          <InputWithIcon
            label={t('booking.lastName', 'Nom')}
            icon={<User size={16} className="text-primary" />}
            type="text"
            name="lastName"
            placeholder="Votre nom"
            value={lastName}
            onChange={(e) => onChange('lastName', e.target.value)}
            required
            disableDarkMode={true}
            className="bg-gray-50/50 focus:bg-white transition-colors duration-200"
          />
        </div>
        
        <div className="mt-5">
          <InputWithIcon
            label={t('booking.email', 'Email')}
            icon={<Mail size={16} className="text-primary" />}
            type="email"
            name="email"
            placeholder="votre.email@exemple.com"
            value={email}
            onChange={(e) => onChange('email', e.target.value)}
            required
            disableDarkMode={true}
            className="bg-gray-50/50 focus:bg-white transition-colors duration-200"
          />
        </div>
        
        <div className="mt-5">
          <InputWithIcon
            label={t('booking.phone', 'Téléphone')}
            icon={<Phone size={16} className="text-primary" />}
            type="tel"
            name="phone"
            placeholder="06 XX XX XX XX"
            value={phone}
            onChange={(e) => onChange('phone', e.target.value)}
            disableDarkMode={true}
            className="bg-gray-50/50 focus:bg-white transition-colors duration-200"
          />
        </div>
        
        <div className="flex items-start mt-5 pt-4 border-t border-gray-100">
          <Info size={14} className="text-amber-500 mt-0.5 mr-2 flex-shrink-0" />
          <div className="text-sm text-gray-500">
            {t('booking.requiredFields', 'Les champs marqués d\'un * sont obligatoires')}
            <p className="mt-1 text-xs text-gray-400">
              {t('booking.privacyNote', 'Vos informations personnelles ne seront utilisées que pour traiter votre réservation et vous contacter en cas de besoin.')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientForm;
